import { render, staticRenderFns } from "./DashboardDataCard.vue?vue&type=template&id=a79e62e8&"
import script from "./DashboardDataCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardDataCard.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardDataCard.vue?vue&type=style&index=0&id=a79e62e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports